import React from 'react';

import * as helpers from './helpers';

const ArrowLeftIcon = ({
  color,
  width = 10,
  height = 18,
  ...props
}: {
  color: string,
  width: number,
  height: number,
}) => (
  <svg
    {...helpers.getSvgDimensionsProps({ width, height })}
    {...helpers.getViewBoxProperty({ width, height })}
    {...props}
  >
    <path
      fill={color}
      d="M2.1455 8.97213L9.10055 2.08359C9.44761 1.73985 9.44761 1.18256 9.10055 0.838826C8.7535 0.495131 8.19082 0.495131 7.84376 0.838826L0.260294 8.34973C-0.0867646 8.69346 -0.0867646 9.25075 0.260294 9.59449L7.84376 17.1054C8.01727 17.2773 8.24475 17.3632 8.47218 17.3632C8.69961 17.3632 8.92709 17.2773 9.1006 17.1054C9.44766 16.7617 9.44766 16.2044 9.1006 15.8606L2.1455 8.97213Z"
    />
  </svg>
);

export default ArrowLeftIcon;
